import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
	baseUrl: process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_SERVER_URL, // Your API domain
	
	providers: {
		facebook: {
			scope: [
				'email',
				'public_profile',
				'user_friends',
				'user_birthday'
			],
			url: 'rest-auth/facebook/',
			clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
			redirectUri: process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_HOST_URL + 'account/social-login/'
		},
		linkedin: {
			scope: [
				'r_liteprofile',
				'r_emailaddress',
				'w_member_social',
			],
			authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
			url: 'rest-auth/linkedin/connect/',
			clientId: '77mr07009kclvl',
			redirectUri: process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_HOST_URL
		},
		facebook_connect: {
      name: 'facebook',
      url: 'rest-auth/facebook/connect/',
      authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
      redirectUri: process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_HOST_URL,
      requiredUrlParams: ['display', 'scope'],
      scope: [
				'email',
				'public_profile',
				'user_friends',
				'user_birthday'
			],
			clientId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 800, height: 500 }
    },

	}
})
